import { useConditionMonitors } from '@/trendData/conditionRuntime.store';
import { withFetchedData } from '@/trendData/runtimeOverlays.utilities';
import { useScalarValues } from '@/trendData/scalarRuntime.store';
import { useTableValues } from '@/trendData/tableRuntime.store';
import type { OverlayableItem } from '@/trendData/runtimeOverlays.utilities';

/**
 * Subscribes to every runtime store the `FETCHED_DATA_MODIFIERS` registry reads and returns their
 * values, for effect dependencies that must re-run when fetched data changes. Extend this and the
 * registry together.
 */
export function useFetchedDataValues(): unknown[] {
  return [useScalarValues(), useTableValues(), useConditionMonitors()];
}

/**
 * Returns the items with the fetched data their types keep in runtime stores overlaid, subscribed
 * so the caller re-renders when that data changes, the behavior items had when the fetched data
 * lived on them.
 */
export function useFetchedData<T extends OverlayableItem>(items: readonly T[]): T[] {
  useFetchedDataValues();
  return items.map((item) => withFetchedData(item));
}
